import React from "react";

const PWAInstall = ({ deferredPrompt, setDeferredPrompt, showButton, setShowButton}) => {
  const handleAddToHomeScreen = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // console.log("User accepted the install prompt");
        } else {
          // console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null); // Reset the prompt
      });
    }
  };

  return (
    showButton && (
      <li>
        <a className='text-black hover:underline focus:outline-none' onClick={handleAddToHomeScreen}>
          הוסף לדף הבית
          {/* Save to Home Screen */}
        </a>
      </li>
    )
  );
};

export default PWAInstall;
